import {ordersService} from 'services';
import AbstractDataSource from 'store/modules/dashboards/dataGetter/dataSources/AbstractDataSource';


class OrdersDataSource extends AbstractDataSource {
  constructor (args) {
    super(args);
    this.service = ordersService;
  }

  get cacheKey () {
    return 'dashboards-orders';
  }

  async makeRequest (dsOrdersParams) {

    // cancel request if there are no selected projects for widget
    if (dsOrdersParams.filteringProjects && dsOrdersParams.filteringProjects.length === 0) {
      return {
        items: [],
        items_total: 0,
        total: {}
      };
    }

    const filtering = [{entity: 'project', entities: dsOrdersParams.filteringProjects}];

    const grouping = dsOrdersParams.orderGrouping;
    if (grouping === 'order' || dsOrdersParams.filteringType === 'order') {
      return await this.service.getAccountOrdersList({
        accountId: this.accountId,
        startDate: dsOrdersParams.dateStart,
        endDate: dsOrdersParams.dateEnd,
        withVat: dsOrdersParams.withVat,
        channelIds: dsOrdersParams.channels,
        accountIds: dsOrdersParams.dashboardAccounts,
        projectId: dsOrdersParams.dashboardProjects ? dsOrdersParams.dashboardProjects : null,
        filtering
      });
    }

    return await this.service.getAccountOrderPeriodsList({
      startDate: dsOrdersParams.dateStart,
      endDate: dsOrdersParams.dateEnd,
      withVat: dsOrdersParams.withVat,
      channelIds: dsOrdersParams.channels,
      accountIds: dsOrdersParams.dashboardAccounts,
      projectId: dsOrdersParams.dashboardProjects ? dsOrdersParams.dashboardProjects : null,
      orderIds: dsOrdersParams.orderIds,
      filtering
    });
  }
}

export default OrdersDataSource;
